import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { FormControl } from 'react-bootstrap';

import { Step } from '~/App/Components/Typeform';
import ActionButton from '~/App/Components/Typeform/ActionButton';

const Note = memo(({ note, updateNote }) => {
  return (
    <Step heading='Task Identifier'>
      <p style={{ color: '#999999' }}>
        This is the name displayed on each contact in the tasklist.
      </p>
      <FormControl
        placeholder='Eg. New sign up'
        defaultValue={note}
        onChange={(evt) => updateNote(evt.target.value)}
      />
      <ActionButton />
    </Step>
  );
});

Note.displayName = 'Task Identifier';

Note.propTypes = {
  note: PropTypes.string,
  updateNote: PropTypes.func,
};

export default Note;
